import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { RoutePaths } from '@nx-customer-apps/shared/enums';
import { StatusPageService } from '../services/status-page.service';

@Injectable({
    providedIn: 'root'
})
export class StatusPageGuardService implements CanActivate {
    constructor(private statusService: StatusPageService, private router: Router) {}

    canActivate(): boolean {
        if (this.statusService.isUnavailable()) {
            this.router.navigate([RoutePaths.ErrorUnavailable], {
                queryParams: { status: this.statusService.getStatus() }
            });
            return false;
        }
        return true;
    }
}
